import { 
	doQuestionEventHandler, 
	initEventCard,
	initRegistrationCard,
	initSpecialButton,
	initIdentificationCard
} from "./toolsHandlers.js";

export default {

	product_card: data => {
		console.log("product_card", data);
		let html = `
			<div class="kb-card kb-product-card">
				<h4 class="heading">${data.title}</h4>
				<div class="actions-group">
					<div class="price">
						<span class="old">${data.old_price}</span>
						<span class="now">${data.price}</span>
					</div>
					<div>
						<a href="${data.link}" class="kb-btn tricky go-to-product" target="_blank">
							Купити
							<svg class="kb-icon" width="24" height="24">
								<use href="#kb-arrow-right"></use>
							</svg>
						</a>
					</div>
				</div>		
			</div>
		`;
		let container = document.createElement("div");
		container.innerHTML = html;
		return container.querySelector(".kb-card");
	},

	identification_card: data => {
		console.log("identification_card", data);
		let html = `
			<div class="kb-card kb-auth-card">
				<div class="description">Введіть номер телефону</div>

				<div class="kb-input-form">
					<label for="kb-phone" class="kb-input-label">Номер телефону</label>
					<div class="kb-input-container">
						<div class="prefix">
							<svg class="kb-icon" width="16" height="16">
								<use href="#kb-ua-flag"></use>
							</svg>
							<span>+380</span>
							<div class="sep"></div>
						</div>
						<input type="phone" id="kb-phone" minlength="9" maxlength="9" placeholder="000000000" class="kb-input">
					</div>
				</div>

				<button class="kb-btn large disabled kb-auth-btn">Відправити</button>
			</div>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		const authCard = container.querySelector(".kb-auth-card");

		initIdentificationCard(authCard);

		return authCard;
	},

	frequentlyQuestions: data => {
		let questions = ``;
		for(let q of data.questions) {
			questions += `
				<button class="kb-btn tricky question" data-do-question="${q}">${q}</button>
			`;
		}

		const html = `
			<div class="frequently-questions">
				<h4 class="heading">Часті запитання:</h4>
				<div class="questions-container">
					${questions}
				</div>
			</div>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		const fquestions = container.querySelector(".frequently-questions");

		fquestions.querySelectorAll("[data-do-question]").forEach(i => {
			i.addEventListener("click", e => {
				doQuestionEventHandler(e);
			});
		});

		return fquestions;
	},

	frequentlyAsked: data => {

		let questions = ``;
		for(let q of data.questions) {
			questions += `
				<button class="kb-btn tricky question" data-do-question="Мене цікавить ${q}">
					<svg class="kb-icon" width="16" height="16">
						<use href="#kb-star"></use>
					</svg>
					${q}
				</button>
			`;
		}

		const html = `
			<div class="frequently-asked">
				<h4 class="heading">Поширені запити:</h4>
				<div class="questions-container">
					${questions}

					<button class="kb-btn tricky question" onclick="showFreqQuests()">
						<svg class="kb-icon" width="16" height="16">
							<use href="#kb-star"></use>
						</svg>
						Часті запитання
					</button>

				</div>
			</div>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		const fquestions = container.querySelector(".frequently-asked");

		fquestions.querySelectorAll("[data-do-question]").forEach(i => {
			i.addEventListener("click", e => {
				doQuestionEventHandler(e);
			});
		});
		return fquestions;
	},

	event_card: data => {
		const datajson = JSON.stringify(data);
		let html = `
			<div class="bot-group">
				<div class="head">
					<div class="name">Bot</div>
				</div>

				<div class="kb-card kb-event-card">
					<div class="kb-heading">${data.title}</div>

					<div class="tags">
						<span class="tag">
							<svg class="kb-icon" width="16" height="16">
								<use href="#kb-calendar"></use>
							</svg>
							<span class="text">${data.date}</span>
						</span>

						<span class="tag">
							<svg class="kb-icon" width="16" height="16">
								<use href="#kb-clock"></use>
							</svg>
							<span class="text">${data.time}</span>
						</span>

						<span class="tag">
							<svg class="kb-icon" width="16" height="16">
								<use href="#kb-map-marker"></use>
							</svg>
							<span class="text">${data.location}</span>
						</span>
					</div>

					<button class="kb-btn tricky reg-to-event" data-json='${datajson}'>Зареєструватись</button>
				</div>
			</div>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		initEventCard(container);
		return container.querySelector(".bot-group");
	},

	registrationCard: data => {
		const json = JSON.stringify(data.data);
		let html = `
			<div class="bot-group">
			<div class="head">
				<div class="name">Bot</div>
			</div>

			<div class="kb-card kb-signup-card" data-type="${data.type}">
				<h4 class="kb-card-heading">Ваші дані</h4>
				<div class="description">Всі поля обов'язкові до заповнення</div>
				<div class="kb-form-group">
					<input type="hidden" name="additional" value='${json}'>
					<div class="kb-input-form">
						<label for="kb-name" class="kb-input-label">Ім’я</label>
						<div class="kb-input-container">
							<input 
								type="text" 
								id="kb-name" 
								name="name"
								maxlength="12" 
								placeholder="Введіть значення" 
								class="kb-input"
							>
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-surname" class="kb-input-label">Прізвище</label>
						<div class="kb-input-container">
							<input 
								type="text" 
								id="kb-surname" 
								name="surname"
								maxlength="12" 
								placeholder="Введіть значення" 
								class="kb-input"
							>
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-phone" class="kb-input-label">Номер телефону</label>
						<div class="kb-input-container">
							<div class="prefix">
								<svg class="kb-icon" width="16" height="16">
									<use href="#kb-ua-flag"></use>
								</svg>
								<span>+380</span>
								<div class="sep"></div>
							</div>
							<input type="phone" id="kb-phone" name="phone" minlength="9" maxlength="9" placeholder="000000000" class="kb-input">
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-city" class="kb-input-label">Місто, де працюєте</label>
						<div class="kb-input-container">
							<select name="city" id="kb-city" class="kb-input">
								<option value="0">Оберіть місто</option>
								<option value="Київ">Київ</option>
								<option value="Харків">Харків</option>
								<option value="Одеса">Одеса</option>
								<option value="Дніпро">Дніпро</option>
								<option value="Запоріжжя">Запоріжжя</option>
								<option value="Львів">Львів</option>
								<option value="Кривий Ріг">Кривий Ріг</option>
								<option value="Миколаїв">Миколаїв</option>
								<option value="Маріуполь">Маріуполь</option>
								<option value="Луганськ">Луганськ</option>
								<option value="Вінниця">Вінниця</option>
								<option value="Макіївка">Макіївка</option>
								<option value="Севастополь">Севастополь</option>
								<option value="Сімферополь">Сімферополь</option>
								<option value="Херсон">Херсон</option>
								<option value="Полтава">Полтава</option>
								<option value="Чернігів">Чернігів</option>
								<option value="Черкаси">Черкаси</option>
								<option value="Хмельницький">Хмельницький</option>
								<option value="Чернівці">Чернівці</option>
								<option value="Житомир">Житомир</option>
								<option value="Суми">Суми</option>
								<option value="Рівне">Рівне</option>
								<option value="Горлівка">Горлівка</option>
								<option value="Краматорськ">Краматорськ</option>
								<option value="Івано-Франківськ">Івано-Франківськ</option>
								<option value="Кременчук">Кременчук</option>
								<option value="Тернопіль">Тернопіль</option>
								<option value="Луцьк">Луцьк</option>
								<option value="Біла Церква">Біла Церква</option>
								<option value="Кам'янське">Кам'янське</option>
								<option value="Кропивницький">Кропивницький</option>
								<option value="Мелітополь">Мелітополь</option>
								<option value="Керч">Керч</option>
								<option value="Нікополь">Нікополь</option>
								<option value="Слов'янськ">Слов'янськ</option>
								<option value="Бердянськ">Бердянськ</option>
								<option value="Павлоград">Павлоград</option>
								<option value="Енергодар">Енергодар</option>
								<option value="Ужгород">Ужгород</option>
								<option value="Лисичанськ">Лисичанськ</option>
								<option value="Бровари">Бровари</option>
								<option value="Сєвєродонецьк">Сєвєродонецьк</option>
								<option value="Алчевськ">Алчевськ</option>
								<option value="Євпаторія">Євпаторія</option>
								<option value="Краматорськ">Краматорськ</option>
							</select>
						</div>
					</div>

					<div class="kb-input-form district-container hide">
						<label for="kb-district" class="kb-input-label">Район міста, де працюєте</label>
						<div class="kb-input-container">
							<select name="district" id="kb-district" class="kb-input">
								<option value="Район не вказано">Оберіть район міста</option>
								<option value="Голосіївський">Голосіївський</option>
								<option value="Дарницький">Дарницький</option>
								<option value="Деснянський">Деснянський</option>
								<option value="Дніпровський">Дніпровський</option>
								<option value="Оболонський">Оболонський</option>
								<option value="Печерський">Печерський</option>
								<option value="Подільський">Подільський</option>
								<option value="Святошинський">Святошинський</option>
								<option value="Солом’янський">Солом’янський</option>
								<option value="Шевченківський">Шевченківський</option>
							</select>
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-specialization" class="kb-input-label">Спеціалізація</label>
						<div class="kb-input-container">
							<input 
								type="text" 
								id="kb-specialization" 
								name="specialization"
								maxlength="12" 
								placeholder="Введіть значення" 
								class="kb-input"
							>
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-buissness-place" class="kb-input-label">Найменування місця ведення діяльності</label>
						<div class="kb-input-container">
							<input 
								type="text" 
								id="kb-buissness-place" 
								name="buissness-place" 
								maxlength="12" 
								placeholder="Введіть значення" 
								class="kb-input"
							>
						</div>
					</div>

					<div class="kb-input-form">
						<label for="kb-brand" class="kb-input-label">Бренд</label>
						<div class="kb-input-container">
							<select name="brand" id="kb-brand" class="kb-input">
								<option value="0">Оберіть бренд</option>
								<option value="Kitan Group">Kitan Group</option>
								<option value="Mediceuticals">Mediceuticals</option>
								<option value="HBloom">HBloom</option>
								<option value="Nubea">Nubea</option>
								<option value="BOSLEY">BOSLEY</option>
							</select>
						</div>
					</div>
				</div>

				<button class="kb-btn large send-form disabled" data-json='${json}'>Відправити</button>
			</div>
			</div>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		initRegistrationCard(container);
		return container.querySelector(".bot-group");
	},

	button: data => {
		data.link = typeof data.link == "undefined" ? "" : data.link;
		data.call = typeof data.call == "undefined" ? "" : data.call;

		let html = `
			<button class="kb-btn large single-btn" data-href="${data.link}" onclick="${data.call}(event)">${data.button_text}</button>
		`;

		let container = document.createElement("div");
		container.innerHTML = html;
		const btn = container.querySelector("button");
		initSpecialButton(btn);
		return container.querySelector(".kb-btn");
	}

}